<ng-container *ngIf="page$ | async as page; else loadingContent">
	<div class="banner" [ngStyle]="{'background-image': page.banner?.value?.length && page.banner?.value[0]?.url ? 'url(\'' + page.banner?.value[0]?.url + '\')' : 'none'}">
		<div class="banner-content-wrapper">
			<div class="banner-content">
				<h1 id="page-title" tabindex="-1">
					<span class="h1" [innerHTML]="page.title?.value"></span>
					<span *ngIf="page.subtitle?.value" class="h2" [innerHTML]="page.subtitle?.value"></span>
				</h1>
			</div>
		</div>
	</div>

	<ng-container *ngIf="page.sections?.linkedItemCodenames?.length">
		<ng-container *ngFor="let section of page.sections?.linkedItemCodenames">
			<ng-container *ngIf="linkedItems[section].system?.type == 'content_section___text'">
				<div class="content-row">
					<div class="container">
						<div class="row">
							<div class="col-12">
								<h2 *ngIf="linkedItems[section].title?.value" class="content-title" [innerHTML]="linkedItems[section].title?.value"></h2>
								<div *ngIf="linkedItems[section].content?.value != '<p><br></p>'" [innerHTML]="linkedItems[section].content?.value"></div>
								<div *ngIf="linkedItems[section].content?.linkedItemCodenames?.length" class="btn-group">
									<a *ngFor="let button of linkedItems[section].content?.linkedItemCodenames"
									   [href]="linkedItems[button].url?.value"
									   [target]="linkedItems[button].openInNewTab?.value?.length && linkedItems[button].openInNewTab?.value[0]?.name == 'Yes' ? '_blank' : '_self'"
									   class="btn btn-primary"
									>{{linkedItems[button].text?.value}}<span *ngIf="linkedItems[button].hiddenScreenAssistText?.value" class="sr-only"> {{linkedItems[button].hiddenScreenAssistText?.value}}</span></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="linkedItems[section].system?.type == 'content_section___brightcove_video'">
				<div class="content-row bg-grey">
					<div class="container">
						<div class="row justify-content-center">
							<div *ngIf="linkedItems[section].description?.value != '<p><br></p>'" [ngClass]="linkedItems[section].brightcove_video_id?.value.includes(',') ? 'col-lg-12' : 'col-lg-6 order-lg-last'">
								<h2 *ngIf="linkedItems[section].title?.value" class="content-title" [innerHTML]="linkedItems[section].title?.value"></h2>
								<div [innerHTML]="linkedItems[section].description?.value" class="introduction-text"></div>
							</div>
							<ng-container *ngFor="let videoID of linkedItems[section].brightcove_video_id?.value.replaceAll(' ', '').split(',')">
								<div [ngClass]="linkedItems[section].brightcove_video_id?.value.includes(',') ? 'col-lg-4 p-3' : 'col-lg-6 p-3'">
									<div class="video-embed-wrapper">
										<iframe [src]="parseVideoIDIntoSrc(videoID)" frameborder="0" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="linkedItems[section].system?.type == 'content_section___brightcove_experience'">
				<div class="content-row">
					<div class="container">
						<div class="row">
							<div class="col-12">
								<h2 *ngIf="linkedItems[section].title?.value" class="content-title" [innerHTML]="linkedItems[section].title?.value"></h2>
								<div *ngIf="linkedItems[section].description?.value != '<p><br></p>'" [innerHTML]="linkedItems[section].description?.value"></div>
								<div *ngIf="linkedItems[section].description?.linkedItemCodenames?.length" class="btn-group">
									<a *ngFor="let button of linkedItems[section].description?.linkedItemCodenames"
									   [href]="linkedItems[button].url?.value"
									   [target]="linkedItems[button].openInNewTab?.value?.length && linkedItems[button].openInNewTab?.value[0]?.name == 'Yes' ? '_blank' : '_self'"
									   class="btn btn-primary"
									>{{linkedItems[button].text?.value}}<span *ngIf="linkedItems[button].hiddenScreenAssistText?.value" class="sr-only"> {{linkedItems[button].hiddenScreenAssistText?.value}}</span></a>
								</div>
								<div [attr.data-experience]="linkedItems[section].brightcove_experience_id?.value"></div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="linkedItems[section].system?.type == 'content_section___full_width_image'">
				<div class="content-row">
					<div class="container">
						<div class="row">
							<div class="col-12">
								<ng-container *ngIf="linkedItems[section].url?.value; else noLinkForImage">
									<a [href]="linkedItems[section].url?.value" [target]="linkedItems[section].open_in_new_tab?.value?.length && linkedItems[section].open_in_new_tab.value[0]?.name == 'Yes' ? '_blank' : '_self'">
										<img [src]="linkedItems[section].image?.value[0]?.url" [alt]="linkedItems[section].image?.value[0]?.description">
									</a>
								</ng-container>
								<ng-template #noLinkForImage>
									<img [src]="linkedItems[section].image?.value[0]?.url" [alt]="linkedItems[section].image?.value[0]?.description">
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="linkedItems[section].system?.type == 'content_section___person_profiles'">
				<div *ngIf="linkedItems[section].profiles?.value?.length" class="content-row bg-grey">
					<div class="container">
						<div *ngFor="let profile of linkedItems[section].profiles.value" class="row bcsi-profile">
							<div class="col-12">
								<img *ngIf="profile.portrait_image?.value?.length" [src]="profile.portrait_image.value[0].url" class="profile-image">
								<h3 class="h3 content-title" [innerHTML]="profile.display_name?.value"></h3>
								<div class="biography" [innerHTML]="profile.bio?.value"></div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="linkedItems[section].system?.type == 'content_section___category_links'">
				<div class="content-row bg-blue">
					<div class="container">
						<div class="row">
							<div [ngClass]="linkedItems[section].category_links?.linkedItemCodenames.length && linkedItems[section].category_links?.linkedItemCodenames.length == 1 ? 'col-lg-6' : 'col-lg-12'">
								<h2 *ngIf="linkedItems[section].title?.value" class="content-title" [innerHTML]="linkedItems[section].title?.value"></h2>
								<div *ngIf="linkedItems[section].content?.value != '<p><br></p>'" [innerHTML]="linkedItems[section].content?.value"></div>
							</div>

							<ng-container *ngIf="linkedItems[section].category_links?.linkedItemCodenames.length">
								<div *ngFor="let link of linkedItems[section].category_links?.linkedItemCodenames" class="col-lg-6">
									<ng-container *ngIf="linkedItems[link].destination?.value?.length && linkedItems[link].destination?.value[0]?.codename == 'external_website'; else internalPageLink">
										<a [href]="linkedItems[link].slug?.value" target="_blank" class="tile r-16-9 tag text-tag tag-bottom" [ngStyle]="{'background-image': linkedItems[link].image?.value?.length && linkedItems[link].image?.value[0]?.url ? 'url(\'' + linkedItems[link].image?.value[0]?.url + '\')' : 'none'}">
											<h2 class="tag" [innerHTML]="linkedItems[link].title?.value"></h2>
										</a>
									</ng-container>
									<ng-template #internalPageLink>
										<a [routerLink]="linkedItems[link].slug?.value" class="tile r-16-9 tag text-tag tag-bottom" [ngStyle]="{'background-image': linkedItems[link].image?.value?.length && linkedItems[link].image?.value[0]?.url ? 'url(\'' + linkedItems[link].image?.value[0]?.url + '\')' : 'none'}">
											<h2 class="tag" [innerHTML]="linkedItems[link].title?.value"></h2>
										</a>
									</ng-template>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="linkedItems[section].system?.type == 'content_section___blog_posts'">
				<div class="content-row">
					<div class="container">
						<div class="row">
							<div class="col-12">
								<h2 *ngIf="linkedItems[section].title?.value" class="content-title" [innerHTML]="linkedItems[section].title?.value"></h2>
								<div *ngIf="linkedItems[section].description?.value != '<p><br></p>'" [innerHTML]="linkedItems[section].description?.value"></div>

								<div *ngIf="linkedItems[section].blog_posts?.value?.length" class="row">
									<div *ngFor="let blogPost of linkedItems[section].blog_posts?.value" class="col-12 my-3">
										<h3 class="h3" [innerHTML]="blogPost.title?.value"></h3>
										<div *ngIf="blogPost.description?.value != '<p><br></p>'" [innerHTML]="blogPost.description?.value"></div>
										<a [href]="blogPost.url?.value" target="_blank" class="btn btn-primary">View Blog Post<span class="sr-only"> for “{{blogPost.title?.value}}”</span></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>

	<ng-content></ng-content>
</ng-container>
<ng-template #loadingContent>
	<div class="dummy-section">
		<div class="content-row">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<div class="h1 dummy-page-title"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="content-row bg-grey">
			<div class="container">
				<div class="row">
					<div class="col-12 text-center">
						<div class="p dummy-text"></div>
						<div class="p dummy-text"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="content-row">
			<div class="container">
				<div class="row">
					<div class="col-12 text-center">
						<div class="p dummy-text"></div>
						<div class="p dummy-text"></div>
						<div class="p dummy-text"></div>
						<br>
						<div class="p dummy-text"></div>
						<div class="p dummy-text"></div>
						<div class="p dummy-text"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
